












































































































































































































































































import Vue from "vue";
import { mapActions, mapMutations, mapState } from "vuex";
import _ from "lodash";
import { PublishmentRegion } from "@/interfaces/publishmentregion";
import { Advertisement } from "@/interfaces/advertisement";
import { PublishmentLocality } from "@/interfaces/publishmentlocality";
export default Vue.extend({
  methods: {
    ...mapMutations(["updateDocument"]),
    ...mapActions(["loadRegions", "loadLocalities"]),
    getRowClass(row: Advertisement) {
      if (!row.publishmentOrder) {
        return "not-yet-ordered";
      }
      const unpublishesAt = new Date(row.publishmentOrder.unpublishesAt);
      unpublishesAt.setHours(0);
      unpublishesAt.setDate(unpublishesAt.getDate() + 1);
      if (unpublishesAt < new Date() ) {
        return "unpublished";
      }
      switch (row.publishmentOrder.publishmentStatus) {
        case "new":
        case "reapplying":
          return "needs-action";
        default:
          break;
      }
    },
    async fetchAdvertisements() {
      this.loading = true;
      const params: { [key: string]: string | number } = {
        page: this.page,
        itemsPerPage: this.perPage
      };
      _.merge(params, this.filterParams);
      params["order[priority]"] = "asc";
      if (this.sortField == "area") {
        params["order[publishmentOrder.region.id]"] = this.sortOrder;
        params["order[publishmentOrder.locality.id]"] = this.sortOrder;
      } else {
        params["order[" + this.sortField + "]"] = this.sortOrder;
      }
      const res = await this.$store.dispatch("get", ["/api/adv/posts", params]);
      this.advertisements = res["hydra:member"];
      this.total = res["hydra:totalItems"];
      this.loading = false;
    },
    onFilterChange: _.debounce(function(this: any) {
      this.fetchAdvertisements();
    }, 200),
    onPageChange(page: number) {
      this.page = page;
      this.fetchAdvertisements();
    },
    onSort(field: string, order: string) {
      this.sortField = field;
      this.sortOrder = order;
      this.fetchAdvertisements();
    },
    getDistributionStatus(advertisement: Advertisement): string {
      if (
        !advertisement.publicAdvertisement ||
        !advertisement.publishmentOrder
      ) {
        return "";
      }
      if (
        ((advertisement.publicAdvertisement as unknown) as {
          postStatus: string;
        }).postStatus == "public"
      ) {
        const now = new Date();
        if (now < new Date(advertisement.publishmentOrder.publishesAt)) {
          return "予約投稿済";
        }
        const unpublishesAt = new Date(advertisement.publishmentOrder.unpublishesAt);
        unpublishesAt.setHours(0);
        unpublishesAt.setDate(unpublishesAt.getDate() + 1);
        if (unpublishesAt < now ) {
          return "掲載終了";
        }
        return "掲載中";
      }
      if (
        ((advertisement.publicAdvertisement as unknown) as {
          postStatus: string;
        }).postStatus == "not_synced"
      ) {
        return "(未連携)";
      }
      if (
        ((advertisement.publicAdvertisement as unknown) as {
          postStatus: string;
        }).postStatus == "suspended"
      ) {
        return "掲載停止中";
      }

      return "";
    }
  },
  mounted() {
    if (this.$route.query.ownerId) {
      this.filters.ownerId = +this.$route.query.ownerId;
    }
    this.fetchAdvertisements();
    this.updateDocument(`
    ## 管理者 広告一覧

    * 登録済みの広告を一覧表示
      - 詳細ボタン押下で詳細画面へ
      - 広告に対する操作は詳細画面から実施
    `);
    this.loadRegions();
    this.loadLocalities();
  },
  computed: {
    ...mapState(["regions", "localities"]),
    // onFilterChangeDebounced() {
    //   return _.debounce(this.onFilterChange, 200);
    // }
    selectableLocalities(): PublishmentLocality[] {
      const selectable = [] as PublishmentLocality[];
      for (const l of this.localities) {
        if (l.region.id == this.filters.publishmentRegion?.id) {
          selectable.push(l);
        }
      }
      return selectable;
    },
    filterParams(): { [key: string]: string } {
      const params = {} as { [key: string]: string };
      if (this.filters.ownerId) {
        params.owner = "" + this.filters.ownerId;
      }

      if (this.filters.ownerName) {
        params["owner.companyName"] = "" + this.filters.ownerName;
      }

      if (this.filters.title) {
        params["title"] = "" + this.filters.title;
      }

      if (this.filters.publishmentRegion) {
        if (this.filters.publishmentRegion.id) {
          params["publishmentOrder.region"] = this.filters.publishmentRegion.id;
        }
      }

      if (this.filters.publishmentLocality) {
        if (this.filters.publishmentLocality.id) {
          params[
            "publishmentOrder.locality"
          ] = this.filters.publishmentLocality.id;
        }
      }

      if (this.filters.hideNotOrdered) {
        params["has_publishmentOrder"] = "1";
      }

      return params;
    }
  },
  data() {
    return {
      advertisements: [],
      page: 1,
      perPage: 10,
      defaultSortOrder: "id",
      sortField: "id",
      sortOrder: "desc",
      total: NaN,
      loading: true,
      filters: {
        publishmentRegion: null as PublishmentRegion | null,
        publishmentLocality: null as PublishmentLocality | null,
        ownerId: null as number | null,
        ownerName: "",
        title: "",
        hideNotOrdered: true
      }
    };
  },
  watch: {
    filters: {
      handler() {
        this.onFilterChange();
      },
      deep: true
    }
  }
});
